import { api, withReducer } from './services';
import {
  getTopbannerAction,
  GET_TOPBANNER_SUCCESS,
  GET_TOPBANNER_FAILURE,
} from './actions/TopbannerAction';
import {
  getAncestorsAction,
  GET_ANCESTORS_SUCCESS,
} from './actions/AncestorsAction';
import { PLATFORMS } from './constants';
import { deserializeCampaign } from './utils/deserializeCampaign';
import { deserializeAncestors } from './utils/deserializeAncestors';

export const initialState = {
  campaign: {},
  platform: PLATFORMS.FRANCE,
  spaceSlug: 'top_banner',
  isB2B: false,
  categoryId: null,
  ancestors: [],
  hasTopbannerBeenFetched: false,
  userId: null,
};

export const actions = {
  getAncestors: (categoryId, platform) => dispatch =>
    api(dispatch, getAncestorsAction(categoryId, platform)),
  getTopbanner: (
    baseUrl,
    platform,
    market,
    pageName,
    ancestors,
    userId,
    isNewUser,
  ) => dispatch =>
    api(
      dispatch,
      getTopbannerAction(
        baseUrl,
        platform,
        market,
        pageName,
        ancestors,
        userId,
        isNewUser,
      ),
    ),
};

export const actionHandlers = {
  [GET_TOPBANNER_SUCCESS]: (state, action) => {
    const { campaign } = action.payload;

    return {
      ...state,
      campaign: campaign ? deserializeCampaign(campaign) : {},
      hasTopbannerBeenFetched: true,
    };
  },
  [GET_TOPBANNER_FAILURE]: state => {
    return {
      ...state,
      hasTopbannerBeenFetched: true,
    };
  },
  [GET_ANCESTORS_SUCCESS]: (state, action) => {
    const { ancestors } = action.payload;

    return {
      ...state,
      ancestors: ancestors
        ? deserializeAncestors(ancestors, state.platform.toUpperCase())
        : [],
    };
  },
};

export const reducer = withReducer(initialState, actionHandlers);
